<!--  商品订单明细详情 -->

<template>
  <div class="detail">
    <back />
    <div class="globle_border" v-loading="loading">
      <h3 class="title">订单信息：</h3>
      <el-row class="row">
        <el-col :span="8">
          <div class="col"><span class="txt">订单编号:</span>{{ detail?.orderNum }}</div>
          <div class="col"><span class="txt">结算类型:</span>
            <span v-if="detail?.orderType == '1'">销售</span>
            <span v-if="detail?.orderType == '2'">退货</span>
          </div>
          <div class="col"><span class="txt">结算金额(元):</span>{{ detail?.settlementAmount }}</div>
        </el-col>
        <el-col :span="8">
          <div class="col"><span class="txt">订单类型:</span>
            <span v-if="detail?.orderSource == '1'">线下订单</span>
            <span v-if="detail?.orderSource == '2'">线上订单</span>
          </div>
          <div class="col"><span class="txt">订单金额(元):</span>{{ detail?.orderAmount }}</div>
          <div class="col"><span class="txt">订单时间:</span>{{ detail?.createdTime }}</div>
        </el-col>
        <el-col :span="8">
          <div class="col"><span class="txt">支付方式:</span>{{ getOrderTypeText(detail?.payType) }}</div>
          <div class="col"><span class="txt">分账金额:</span>{{ detail?.commissionAmount }}</div>
        </el-col>
      </el-row>

      <h3 class="title">商品详情：</h3>
      <!-- 表格 -->
      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="barCode" label="商品条形码"></el-table-column>
          <el-table-column min-width="180" show-overflow-tooltip prop="productName" label="商品名称"></el-table-column>
          <el-table-column show-overflow-tooltip prop="brand" label="品牌"></el-table-column>
          <el-table-column show-overflow-tooltip prop="specs" label="规格"></el-table-column>
          <el-table-column show-overflow-tooltip prop="categoryName" label="商品类目"></el-table-column>
          <el-table-column min-width="120" show-overflow-tooltip prop="productCount" label="购买数量"></el-table-column>
          <el-table-column min-width="120" show-overflow-tooltip prop="productPrice" label="销售价(元)"></el-table-column>
          <el-table-column min-width="120" show-overflow-tooltip prop="productAmount" label="总价(元)"></el-table-column>
          <el-table-column min-width="120" show-overflow-tooltip prop="commissionRate"
            label="分账比例(%)"></el-table-column>
          <el-table-column min-width="120" show-overflow-tooltip prop="commissionAmount"
            label="分账金额(元)"></el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      id: null,
      detail: {},
      // 表格数据
      tableData: [],
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getDetails()
  },
  methods: {
    // 获取列表
    getDetails() {
      this.loading = true;
      this.$axios.get(`${this.$api.getSettlementOrderDetail}/${this.id}`).then((res) => {
        if (res.code == 100) {
          this.detail = res.result;
          this.tableData = res.result.settlementDetailVoList;
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },

    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.clearData()
      this.pageSize = e
      this.getDetails()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getDetails()
    },
    // 支付类型
    getOrderTypeText(status) {
      switch (String(status)) {
        case "0":
          return "现金支付"
        case "1":
          return "线上支付"
        case "3":
          return "会员卡支付"
        default:
          return ""
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.detail {
  .title {
    margin-bottom: 25px;
  }

  .row {
    color: #707070;
  }

  .col {
    margin-bottom: 25px;
  }

  .txt {
    margin-right: 8px;
  }

  .hr {
    width: 1580px;
    height: 1px;
    background: #dedede;
    border-radius: 10px 10px 0px 0px;
    margin: 10px 0 30px 0;
  }
}
</style>
